import { ArrowRight, Sparkles } from "lucide-react";

export const FoundingRevenueBlock = ({ onSeatCheckoutStart }) => (
  <section className="section-shell pt-6" data-testid="founding-revenue-block-shell">
    <div className="overflow-hidden rounded-[36px] border border-[#D4AF37]/22 bg-[linear-gradient(135deg,#fffaf1_0%,#f7ecd6_48%,#eadbb4_100%)] p-8 shadow-[0_32px_90px_rgba(0,25,53,0.12)] lg:p-10" data-testid="founding-revenue-block">
      <div className="grid gap-8 lg:grid-cols-[1.1fr_0.9fr] lg:items-end">
        <div>
          <p className="text-xs font-bold uppercase tracking-[0.24em] text-[#8b6d16]">Founding 11 Revenue Block</p>
          <h2 className="mt-3 text-4xl font-semibold leading-tight text-[#001935] md:text-5xl">Partner with the Platform.</h2>
          <p className="mt-4 max-w-3xl text-sm leading-8 text-[#42566f] md:text-base">128 multi-agent signals are being routed to our Founding 11 right now. Only 4 seats remain before the network closes.</p>
        </div>

        <div className="rounded-[28px] border border-[#001935]/10 bg-white/80 p-6" data-testid="founding-revenue-block-card">
          <p className="text-xs font-bold uppercase tracking-[0.18em] text-[#8b6d16]">Only 4 Seats Remaining</p>
          <p className="mt-4 text-sm leading-7 text-[#42566f]">Direct founder checkout is now live. Move straight into the Stripe founder seat flow and secure your Signature position.</p>
          <button className="gold-button mt-6 w-full justify-center" data-testid="founding-revenue-block-secure-seat-button" onClick={onSeatCheckoutStart} type="button">
            Secure My Seat <Sparkles className="ml-2 h-4 w-4" />
          </button>
          <p className="mt-3 inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.16em] text-[#001935]">
            Live founder checkout <ArrowRight className="h-3.5 w-3.5" /> no extra steps
          </p>
        </div>
      </div>
    </div>
  </section>
);